// extracted by mini-css-extract-plugin
export var askAiIcon = "_ki-9";
export var container = "_ki-0";
export var groupSeparator = "_ki-a";
export var highlight = "_ki-4";
export var resultIcon = "_ki-5";
export var resultItem = "_ki-7";
export var resultSubtitle = "_ki-3";
export var resultTitle = "_ki-2";
export var resultsList = "_ki-1";
export var searchGroup = "_ki-6";
export var selected = "_ki-8";